import React from 'react';
import { useSelector } from 'react-redux';
import { UseFormReturn } from 'react-hook-form';
import { MarginProps } from '../../../../../theme/styledProps';
import { SectionHeader } from '../SectionHeader/SectionHeader';
import { Box } from '../../../../../CommonComponents/OPL/Box/Box';
import { Toggle } from '../../../../../CommonComponents/OPL/Toggle/Toggle';
import { FormValues } from '../../FirmSettings.meta';
import { selectAssetBucketingHeadline } from '../../../../../CommonSelectors/CommonAreaSelector';

interface Props extends MarginProps {
  formBag: UseFormReturn<FormValues>;
}

export const AssetBucketing: React.FC<Props> = ({ formBag, ...rest }) => {
  const assetBucketingHeadline = useSelector(selectAssetBucketingHeadline);

  const toggleOne = 'allowAssetBucketing';
  const toggleTwo = 'allowClientToCustomizeAssetAssignmentAcrossBuckets';
  const toggleThree = 'allowAdvisersToDelegateClientLevelAssetBucketingCustomization';
  const toggleFour = 'allowAdvisersToCustomizeAssetBucketingLayout';

  return (
    <Box as="section" {...rest}>
      <SectionHeader title={`Asset Bucketing - ${assetBucketingHeadline}`} />

      <Toggle
        {...formBag.register(toggleOne)}
        onChange={e => formBag.setValue(toggleTwo, e.target.checked)}
      >
        {`Allow Advisors to Access ${assetBucketingHeadline} Results`}
      </Toggle>

      <Toggle
        {...formBag.register(toggleFour)}
        onChange={() => !formBag.getValues(toggleOne) && formBag.setValue(toggleOne, true)}
        mt="24"
      >
        {`Allow Advisors to Create ${assetBucketingHeadline}`}
      </Toggle>

      <Toggle
        {...formBag.register(toggleThree)}
        onChange={() => !formBag.getValues(toggleOne) && formBag.setValue(toggleOne, true)}
        mt="24"
      >
        {`Allow Advisors to Delegate Client-Level ${assetBucketingHeadline} Customizations Permissions`}
      </Toggle>

      <Toggle
        {...formBag.register(toggleTwo)}
        onChange={() => !formBag.getValues(toggleOne) && formBag.setValue(toggleOne, true)}
        mt="24"
      >
        Allow Clients to Customize Asset Assignment Across Buckets
      </Toggle>
    </Box>
  );
};
